<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Product Instruction {{ (inputInstruction) ? (" - " + this.inputInstruction) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Product Instruction - {{this.inputInstruction}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Product Instruction - {{this.inputInstruction}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <!-- <b><label>Created by: </label></b>
                {{product_instructions.created_by}} | {{product_instructions.created_at | dateFilter}} 
                <br>
                <b><label>Updated by:</label></b>
                {{product_instructions.updated_by}} | {{product_instructions.updated_at | dateFilter}}  -->
                <!-- <div>
                    <a-table :columns="historyColumns" :dataSource="historyData" size="small" />
                </div> -->
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <div v-if="customFormMode == 1" v-show="showDetails">
                 <base-input alternative="" label="Product Category" input-classes="form-control" required>
                    <a-select
                        v-model="product_instructions.product_categories"
                        mode="multiple"
                        style="width: 100%"
                        placeholder="Select Product Categories"
                        optionFilterProp="children"
                        @change="getSelectedProductCategory"
                        :disabled="viewMode">
                            <a-select-option v-for="category in product_category_list"
                                    :key="category.id"
                                    :value="category.name">{{ category.name }}
                            </a-select-option>
                    </a-select>
                </base-input>
                <base-input alternative="" label="Instruction" placeholder="" v-model="product_instructions.instruction" input-classes="form-control" :disabled="viewMode" />
                <!-- <base-input alternative="" label="Sequence Number" placeholder="" v-model="category.name" input-classes="form-control" required /> -->
            </div>
            <div v-if="this.$attrs.viewMode != true">
                <div  v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import DynamicForm from '../DynamicForm.vue'
    import { mapState } from 'vuex'
    import moment from 'moment'
    var component_x;

    const histories_column = [
        { title: "Action", dataIndex: "action", key: "action" },
        { title: "Field Name", dataIndex: "field_name", key: "field_name" },
        { title: "From", dataIndex: "old_value", key: "old_value" },
        { title: "To", dataIndex: "new_value", key: "new_value" },
        { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
        // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
        { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
    ];

    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Product Instructions?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId +'?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
             const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
             if(accSystemModule != null){
                 if(accSystemModule.form_mode != undefined){
                     this.customFormMode = accSystemModule.form_mode
                 }
                 if(accSystemModule.customized_forms != undefined){
                     this.customForm = accSystemModule.customized_forms
                 }
             }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this

            if (component_x.profileId == 0){
                var product_categories = await HTTPRequest.getRequest(component_x.endPoint + 'categories/get_product_categories', null)
                if(product_categories == undefined){
                    component_x.$router.go()
                } else {
                    if(product_categories["error"] == undefined){
                        component_x.product_category_list = product_categories;
                        component_x.inputInstruction = product_categories["instruction"]
                    } else {
                        this.errors = product_categories["error"].split(",");
                    } 
                }
            } 
             if (component_x.profileId > 0){
                var product_categories = await HTTPRequest.getRequest(component_x.endPoint + 'categories/get_product_categories', null)
                if(product_categories == undefined){
                    component_x.$router.go()
                } else {
                    if(product_categories["error"] == undefined){
                        component_x.product_category_list = product_categories;
                        component_x.inputInstruction = product_categories["instruction"]
                    } else {
                        this.errors = product_categories["error"].split(",");
                    } 
                }
                var product_instruction_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_instructions/' + component_x.profileId, null)
                if(product_instruction_data == undefined){
                    component_x.$router.go()
                } else {
                    if(product_instruction_data["error"] == undefined){
                        component_x.product_instructions = product_instruction_data
                        component_x.inputInstruction = product_instruction_data["instruction"]
                    } else {
                        this.errors = product_instruction_data["error"].split(",");
                    } 
                }
            }
            this.dynamicFormKey++;
        },
        data: function () {
            return {
                inputInstruction: '',
                errors: [],
                showDetails: true,
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                product_category_list: [],
                product_instructions: {},
                formErrors: [],
                viewMode: this.$attrs.viewMode,

                historyVisible: false,
                historyColumns: histories_column,
                historyData: null,
                loading: false,
                pagination: false,
            }
        },
        filters: {
            dateFilter: function (timestamp) {
                return moment(timestamp).format('L LTS')
            }
        },
        methods: {
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            openDetails() {
                this.showDetails = true
            },
            async openHistory() {
                this.showDetails = false
                let product_instruction_id = this.product_instructions.id
                let customerHistory = await HTTPRequest.getRequest(this.endPoint + "product_instruction_update_histories?product_instruction_id=" + product_instruction_id, null, null);
                this.historyData = customerHistory
            },
            getSelectedProductCategory(value){
                this.product_instructions.product_categories = value;
            },
            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.required('Product Instruction', this.product_instructions.instruction));
                // this.errors.push(ValidateField.required('Product Category', this.product_instructions.product_categories));
                this.errors.push(ValidateField.charMinAndMax('Product Instruction', this.product_instructions.instruction, 0, 100));
                
                if(this.product_instructions.product_categories == undefined || this.product_instructions.product_categories.length == 0){
                    this.errors.push("Product Category is required.")
                }

                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    if (this.product_instructions.instruction != undefined)
                        this.product_instructions.instruction = this.product_instructions.instruction.trim()
                    this.product_instructions.status = 'A'
                    var productDetailsPayload = { product_instruction: this.product_instructions }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'product_instructions', null, productDetailsPayload)    
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    if (this.product_instructions.instruction != undefined)
                        this.product_instructions.instruction = this.product_instructions.instruction.trim()
                    let status = (this.product_instructions.status == null) ?  "A" : this.product_instructions.status
                    this.product_instructions.status = status

                    var productDetailsPayload = { product_instruction: this.product_instructions }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_instructions/' + this.profileId, null, productDetailsPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>